import React from 'react';
import {
    StyledH1,
    StyledH2,
    StyledH3,
    StyledH4,
    StyledSubHead,
    StyledBody,
    StyledSmall,
    StyledTiny,
} from './styles';

import { TypographyProps } from './types';

const Typography: React.FC<TypographyProps> = ({
    children,
    variant = 'body',
    weight = 'regular',
    align = 'left',
    color,
    ...rest
}: TypographyProps) => {
    switch (variant) {
        case 'h1':
            return (
                <StyledH1 color={color} weight={weight} align={align} {...rest}>
                    {children}
                </StyledH1>
            );
        case 'h2':
            return (
                <StyledH2 color={color} weight={weight} align={align} {...rest}>
                    {children}
                </StyledH2>
            );
        case 'h3':
            return (
                <StyledH3 color={color} weight={weight} align={align} {...rest}>
                    {children}
                </StyledH3>
            );
        case 'h4':
            return (
                <StyledH4 color={color} weight={weight} align={align} {...rest}>
                    {children}
                </StyledH4>
            );
        case 'subHeading':
            return (
                <StyledSubHead color={color} weight={weight} align={align} {...rest}>
                    {children}
                </StyledSubHead>
            );
        case 'body':
            return (
                <StyledBody color={color} weight={weight} align={align} {...rest}>
                    {children}
                </StyledBody>
            );
        case 'small':
            return (
                <StyledSmall color={color} weight={weight} align={align} {...rest}>
                    {children}
                </StyledSmall>
            );
        case 'tiny':
            return (
                <StyledTiny color={color} weight={weight} align={align} {...rest}>
                    {children}
                </StyledTiny>
            );
        default:
            return (
                <StyledBody color={color} weight={weight} align={align} {...rest}>
                    {children}
                </StyledBody>
            );
    }
};

const isEqual = (prevProps: any, nextProps: any) => {
    return false;
};

export default React.memo(Typography, isEqual);
